import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/order-empty.png'


const _withScopeId = n => (_pushScopeId("data-v-33fa92f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order-content" }
const _hoisted_3 = { class: "order-tab" }
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = { class: "order-list-status" }
const _hoisted_6 = { class: "order-list-product" }
const _hoisted_7 = { class: "product-img" }
const _hoisted_8 = { class: "product-info" }
const _hoisted_9 = { class: "fontset" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "积分", -1))
const _hoisted_11 = { class: "fontset" }
const _hoisted_12 = { class: "order-list-cost" }
const _hoisted_13 = { class: "fontset num" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1))
const _hoisted_15 = { class: "fontset" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "empty"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无订单", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "roage"
}
const _hoisted_22 = ["title", "onClick"]
const _hoisted_23 = { class: "order-list-status" }
const _hoisted_24 = { class: "order-list-product" }
const _hoisted_25 = { class: "product-img" }
const _hoisted_26 = { class: "product-info" }
const _hoisted_27 = { class: "fontset" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "积分", -1))
const _hoisted_29 = { class: "fontset" }
const _hoisted_30 = { class: "order-list-cost" }
const _hoisted_31 = { class: "fontset num" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1))
const _hoisted_33 = { class: "fontset" }
const _hoisted_34 = {
  key: 0,
  class: "empty"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无订单", -1))
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = {
  key: 0,
  class: "roage"
}
const _hoisted_39 = ["title", "onClick"]
const _hoisted_40 = { class: "order-list-status" }
const _hoisted_41 = { class: "order-list-product" }
const _hoisted_42 = { class: "product-img" }
const _hoisted_43 = { class: "product-info" }
const _hoisted_44 = { class: "fontset" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "积分", -1))
const _hoisted_46 = { class: "fontset" }
const _hoisted_47 = { class: "order-list-cost" }
const _hoisted_48 = { class: "fontset num" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1))
const _hoisted_50 = { class: "fontset" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 0,
  class: "empty"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无订单", -1))
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = ["title", "onClick"]
const _hoisted_57 = { class: "order-list-status" }
const _hoisted_58 = { class: "black-word" }
const _hoisted_59 = { class: "order-list-product" }
const _hoisted_60 = { class: "product-img" }
const _hoisted_61 = { class: "product-info" }
const _hoisted_62 = { class: "fontset" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "积分", -1))
const _hoisted_64 = { class: "fontset" }
const _hoisted_65 = { class: "order-list-cost" }
const _hoisted_66 = { class: "fontset num" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1))
const _hoisted_68 = { class: "fontset" }
const _hoisted_69 = {
  key: 0,
  class: "empty"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无订单", -1))
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = ["title", "onClick"]
const _hoisted_74 = { class: "order-list-status" }
const _hoisted_75 = { class: "gray-word" }
const _hoisted_76 = { class: "order-list-product" }
const _hoisted_77 = { class: "product-img" }
const _hoisted_78 = { class: "product-info" }
const _hoisted_79 = { class: "fontset" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "积分", -1))
const _hoisted_81 = { class: "fontset" }
const _hoisted_82 = { class: "order-list-cost" }
const _hoisted_83 = { class: "fontset num" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1))
const _hoisted_85 = { class: "fontset" }
const _hoisted_86 = {
  key: 0,
  class: "empty"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无订单", -1))
const _hoisted_89 = [
  _hoisted_87,
  _hoisted_88
]

import { ref, onActivated, watch } from 'vue';
    import Navigate from "@/components/Navigate";
    import { useRouter } from "vue-router";
    import { exchangeOrderList } from '@/server/api'
    import { useStore } from 'vuex';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderList',
  setup(__props) {

    const $router = useRouter();
    const store = useStore();

    const pageNum = ref(1);
    const anotherCount = ref(0);
    const active = ref(0);
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const status = ref('ALL');
    const refreshPage = ref(true);
    const showStatus = ref({
        'TO_BE_SHIPPED': '待发货',
        'SHIPPED': '待收货',
        'FINISHED': '已完成',
        'CANCEL': '已取消'
    })

    const activeStatus = ref({
        '0': 'ALL',
        '1': 'TO_BE_SHIPPED',
        '2': 'SHIPPED',
        '3': 'FINISHED',
        '4': 'CANCEL'
    })

    const finishedText = ref('');
    const isRequestStatus = ref(false);
    const isFormExchange = ref('');
    const waitReceivedNum = ref(0)
    const shippedNum = ref(0)

    onActivated(() => {
        isFormExchange.value = $router.currentRoute.value.query?.isFormExchange as string;
        store.dispatch("setOrderDetails", '')
    })

    // 监听active改变更新数据接口
    watch(active, (newValue, oldValue) => {
        if(newValue===oldValue) {
            return
        }
        list.value = [];
        isRequestStatus.value = false;
        status.value = activeStatus.value[newValue];
        console.log(status.value)
        pageNum.value = 1;
        finished.value = false;
        // if(newValue === 1) {
        //     waitReceivedNum.value = 0;
        // }else if(newValue === 2) {
        //    shippedNum.value = 0;
        // }
        // 加载状态结束
        loading.value = true;
        finishedText.value = "";
        onLoad()
    })

    const getOrderList = async(status : any) => {
        const params = {
            userId: store.state.openId || window.localStorage.getItem('openId'),
            page: pageNum.value,
            pageSize: 20,
            orderStatus: status.value
        }
        const  {data}  = await exchangeOrderList(params);
        list.value = list.value.concat(data.orders)
        isRequestStatus.value = true;
        if(refreshPage.value) {
            waitReceivedNum.value = data.waitReceivedNum;
            shippedNum.value = data.shippedNum;
            refreshPage.value = false;
        }

        // 加载状态结束
        loading.value = false;

        // 数据全部加载完成
        // if (data.orders.length < 20) {
          finished.value = true;
          if(list.value.length !== 0) {
            finishedText.value = "- 已显示全部 -";
          }
        // }
    }

    const onLoad = () => {
        console.log(11111)
      setTimeout(() => {
        
        if(!finished.value) {
            getOrderList(status)
            pageNum.value = pageNum.value + 1;
        }
      }, 1000);
    };

    const lookDetails = (item: Object) => {
        store.dispatch("setOrderDetails", JSON.parse(JSON.stringify(item)))
        $router.push({
            name: "orderDetail",
            query:{
                isFormExchange: isFormExchange.value
            }
        });
    };

    const toExpressNo = (no: any) => {
        window.location.href = `https://m.kuaidi100.com/app/query/?nu=${no}&coname=${store.state.currentState}`
    }


return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_tabs, {
          active: active.value,
          "onUpdate:active": _cache[5] || (_cache[5] = ($event: any) => ((active).value = $event)),
          color: "#FF3469",
          "title-class": "custom-tab"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_tab, null, {
              title: _withCtx(() => [
                _createTextVNode("全部")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_van_list, {
                  loading: loading.value,
                  "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
                  finished: finished.value,
                  "finished-text": finishedText.value,
                  onLoad: onLoad
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item,
                        title: item,
                        class: "order-list",
                        onClick: ($event: any) => (lookDetails(item))
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("p", null, [
                            _createElementVNode("span", null, [
                              _createTextVNode("订单编号："),
                              _createElementVNode("em", null, _toDisplayString(item.orderCode), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _createTextVNode("兑换时间："),
                              _createElementVNode("em", null, _toDisplayString(item.createTime), 1)
                            ])
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(item.orderStatus == 'FINISHED' ? 'black-word' : item.orderStatus == 'CANCEL' ? 'gray-word' : '')
                          }, _toDisplayString(showStatus.value[item.orderStatus]), 3)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_van_image, {
                              src: item.productImage
                            }, {
                              loading: _withCtx(() => [
                                _createVNode(_component_van_loading, {
                                  type: "spinner",
                                  size: "20"
                                })
                              ]),
                              _: 2
                            }, 1032, ["src"])
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("p", null, _toDisplayString(item.productName), 1),
                            _createElementVNode("p", null, _toDisplayString(item.subTitle), 1),
                            _createElementVNode("p", null, [
                              _createElementVNode("span", _hoisted_9, [
                                _createTextVNode(_toDisplayString(item.points), 1),
                                _hoisted_10
                              ]),
                              _createElementVNode("span", _hoisted_11, "x" + _toDisplayString(item.quantity), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("p", null, [
                            _createTextVNode("共 "),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(item.quantity), 1),
                            _createTextVNode(" 件"),
                            _hoisted_14,
                            _createTextVNode("共计："),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(item.usePoints), 1),
                            _createTextVNode("积分")
                          ]),
                          (item.expressNo)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "button",
                                onClick: _withModifiers(($event: any) => (lookDetails(item)), ["prevent"])
                              }, "查看详情", 8, _hoisted_16))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_4))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "finished", "finished-text"]),
                (list.value.length === 0 && finished.value && isRequestStatus.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_van_tab, null, {
              title: _withCtx(() => [
                _createTextVNode("待发货"),
                (Number(waitReceivedNum.value))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(waitReceivedNum.value), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_van_list, {
                  loading: loading.value,
                  "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
                  finished: finished.value,
                  "finished-text": finishedText.value,
                  onLoad: onLoad
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item,
                        title: item,
                        class: "order-list",
                        onClick: ($event: any) => (lookDetails(item))
                      }, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("p", null, [
                            _createElementVNode("span", null, [
                              _createTextVNode("订单编号："),
                              _createElementVNode("em", null, _toDisplayString(item.orderCode), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _createTextVNode("兑换时间："),
                              _createElementVNode("em", null, _toDisplayString(item.createTime), 1)
                            ])
                          ]),
                          _createElementVNode("span", null, _toDisplayString(showStatus.value[item.orderStatus]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_van_image, {
                              src: item.productImage
                            }, {
                              loading: _withCtx(() => [
                                _createVNode(_component_van_loading, {
                                  type: "spinner",
                                  size: "20"
                                })
                              ]),
                              _: 2
                            }, 1032, ["src"])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("p", null, _toDisplayString(item.productName), 1),
                            _createElementVNode("p", null, _toDisplayString(item.subTitle), 1),
                            _createElementVNode("p", null, [
                              _createElementVNode("span", _hoisted_27, [
                                _createTextVNode(_toDisplayString(item.points), 1),
                                _hoisted_28
                              ]),
                              _createElementVNode("span", _hoisted_29, "x" + _toDisplayString(item.quantity), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("p", null, [
                            _createTextVNode("共"),
                            _createElementVNode("span", _hoisted_31, _toDisplayString(item.quantity), 1),
                            _createTextVNode("件"),
                            _hoisted_32,
                            _createTextVNode("共计："),
                            _createElementVNode("span", _hoisted_33, _toDisplayString(item.usePoints), 1),
                            _createTextVNode("积分")
                          ])
                        ])
                      ], 8, _hoisted_22))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "finished", "finished-text"]),
                (list.value.length === 0 && finished.value && isRequestStatus.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_37))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_van_tab, null, {
              title: _withCtx(() => [
                _createTextVNode("待收货"),
                (Number(shippedNum.value))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(shippedNum.value), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_van_list, {
                  loading: loading.value,
                  "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
                  finished: finished.value,
                  "finished-text": finishedText.value,
                  onLoad: onLoad
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item,
                        title: item,
                        class: "order-list",
                        onClick: ($event: any) => (lookDetails(item))
                      }, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("p", null, [
                            _createElementVNode("span", null, [
                              _createTextVNode("订单编号："),
                              _createElementVNode("em", null, _toDisplayString(item.orderCode), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _createTextVNode("兑换时间："),
                              _createElementVNode("em", null, _toDisplayString(item.createTime), 1)
                            ])
                          ]),
                          _createElementVNode("span", null, _toDisplayString(showStatus.value[item.orderStatus]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_component_van_image, {
                              src: item.productImage
                            }, {
                              loading: _withCtx(() => [
                                _createVNode(_component_van_loading, {
                                  type: "spinner",
                                  size: "20"
                                })
                              ]),
                              _: 2
                            }, 1032, ["src"])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("p", null, _toDisplayString(item.productName), 1),
                            _createElementVNode("p", null, _toDisplayString(item.subTitle), 1),
                            _createElementVNode("p", null, [
                              _createElementVNode("span", _hoisted_44, [
                                _createTextVNode(_toDisplayString(item.points), 1),
                                _hoisted_45
                              ]),
                              _createElementVNode("span", _hoisted_46, "x" + _toDisplayString(item.quantity), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("p", null, [
                            _createTextVNode("共"),
                            _createElementVNode("span", _hoisted_48, _toDisplayString(item.quantity), 1),
                            _createTextVNode("件"),
                            _hoisted_49,
                            _createTextVNode("共计："),
                            _createElementVNode("span", _hoisted_50, _toDisplayString(item.usePoints), 1),
                            _createTextVNode("积分")
                          ]),
                          (item.expressNo)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "button",
                                onClick: _withModifiers(($event: any) => (lookDetails(item)), ["prevent"])
                              }, "查看详情", 8, _hoisted_51))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_39))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "finished", "finished-text"]),
                (list.value.length === 0 && finished.value && isRequestStatus.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_55))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_van_tab, null, {
              title: _withCtx(() => [
                _createTextVNode("已完成")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_van_list, {
                  loading: loading.value,
                  "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((loading).value = $event)),
                  finished: finished.value,
                  "finished-text": finishedText.value,
                  onLoad: onLoad
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item,
                        title: item,
                        class: "order-list",
                        onClick: ($event: any) => (lookDetails(item))
                      }, [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("p", null, [
                            _createElementVNode("span", null, [
                              _createTextVNode("订单编号："),
                              _createElementVNode("em", null, _toDisplayString(item.orderCode), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _createTextVNode("兑换时间："),
                              _createElementVNode("em", null, _toDisplayString(item.createTime), 1)
                            ])
                          ]),
                          _createElementVNode("span", _hoisted_58, _toDisplayString(showStatus.value[item.orderStatus]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_van_image, {
                              src: item.productImage
                            }, {
                              loading: _withCtx(() => [
                                _createVNode(_component_van_loading, {
                                  type: "spinner",
                                  size: "20"
                                })
                              ]),
                              _: 2
                            }, 1032, ["src"])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("p", null, _toDisplayString(item.productName), 1),
                            _createElementVNode("p", null, _toDisplayString(item.subTitle), 1),
                            _createElementVNode("p", null, [
                              _createElementVNode("span", _hoisted_62, [
                                _createTextVNode(_toDisplayString(item.points), 1),
                                _hoisted_63
                              ]),
                              _createElementVNode("span", _hoisted_64, "x" + _toDisplayString(item.quantity), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("p", null, [
                            _createTextVNode("共"),
                            _createElementVNode("span", _hoisted_66, _toDisplayString(item.quantity), 1),
                            _createTextVNode("件"),
                            _hoisted_67,
                            _createTextVNode("共计："),
                            _createElementVNode("span", _hoisted_68, _toDisplayString(item.usePoints), 1),
                            _createTextVNode("积分")
                          ])
                        ])
                      ], 8, _hoisted_56))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "finished", "finished-text"]),
                (list.value.length === 0 && finished.value && isRequestStatus.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_72))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_van_tab, null, {
              title: _withCtx(() => [
                _createTextVNode("已取消")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_van_list, {
                  loading: loading.value,
                  "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((loading).value = $event)),
                  finished: finished.value,
                  "finished-text": finishedText.value,
                  onLoad: onLoad
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item,
                        title: item,
                        class: "order-list",
                        onClick: ($event: any) => (lookDetails(item))
                      }, [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("p", null, [
                            _createElementVNode("span", null, [
                              _createTextVNode("订单编号："),
                              _createElementVNode("em", null, _toDisplayString(item.orderCode), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _createTextVNode("兑换时间："),
                              _createElementVNode("em", null, _toDisplayString(item.createTime), 1)
                            ])
                          ]),
                          _createElementVNode("span", _hoisted_75, _toDisplayString(showStatus.value[item.orderStatus]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_van_image, {
                              src: item.productImage
                            }, {
                              loading: _withCtx(() => [
                                _createVNode(_component_van_loading, {
                                  type: "spinner",
                                  size: "20"
                                })
                              ]),
                              _: 2
                            }, 1032, ["src"])
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("p", null, _toDisplayString(item.productName), 1),
                            _createElementVNode("p", null, _toDisplayString(item.subTitle), 1),
                            _createElementVNode("p", null, [
                              _createElementVNode("span", _hoisted_79, [
                                _createTextVNode(_toDisplayString(item.points), 1),
                                _hoisted_80
                              ]),
                              _createElementVNode("span", _hoisted_81, "x" + _toDisplayString(item.quantity), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("p", null, [
                            _createTextVNode("共"),
                            _createElementVNode("span", _hoisted_83, _toDisplayString(item.quantity), 1),
                            _createTextVNode("件"),
                            _hoisted_84,
                            _createTextVNode("共计："),
                            _createElementVNode("span", _hoisted_85, _toDisplayString(item.usePoints), 1),
                            _createTextVNode("积分")
                          ])
                        ])
                      ], 8, _hoisted_73))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "finished", "finished-text"]),
                (list.value.length === 0 && finished.value && isRequestStatus.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, _hoisted_89))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ])
  ]))
}
}

})